import * as React from 'react'
import { BREAKPOINT_DESKTOP, COLORS, MOBILE_HEADER_HEIGHT } from 'static/constants'
import styled from 'styled-components'
import { SidebarContent } from './SidebarContent'

interface IDashOBarNavItemProps {
  open?: boolean
  roleLabel: string
  approvedUser: boolean
  expanded: boolean
}

const ExpandableSidebar: React.VFC<IDashOBarNavItemProps> = ({
  open,
  roleLabel,
  approvedUser,
  expanded,
}) => {
  return (
    <Sidebar open={open} className={`${open || !expanded ? '' : 'closed'}`}>
      <div className="Scroller">
        <SidebarContent roleLabel={roleLabel} approvedUser={approvedUser} />
      </div>
    </Sidebar>
  )
}

const Sidebar = styled.div`
  position: relative;
  width: 260px;
  min-height: 100%;
  flex-shrink: 0;
  text-align: center;
  display: block;
  flex-direction: column;
  padding: 22px 20px 22px 0;
  margin-right: 20px;
  border: 1px solid transparent;
  background: ${COLORS.background};
  transition: all ease-in-out 0.1s;
  box-shadow: 0 0 0 transparent;

  &.closed {
    position: absolute;
    overflow: hidden;
    z-index: 100;
    width: 10px;
    margin-top: 20px;
    margin-right: 0;
    min-height: min-content;
    box-shadow: ${COLORS.floatShadow};
    border-radius: 0 5px 5px 0;
    border-color: ${COLORS.divider};
    padding: 22px 10px 22px 0;
    .Scroller {
      overflow: hidden;
      padding-right: 30px;
    }
    :hover {
      width: 260px;
    }
  }

  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    overflow: ${props => (props.open ? 'auto' : 'hidden')};
    width: ${props => (props.open ? 'auto' : 0)};
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: ${COLORS.background};
    z-index: 1000;
    padding: ${MOBILE_HEADER_HEIGHT}px 0;
    ${props =>
      props.active &&
      `
      border-left: 4px solid ${COLORS.primary};
    `};
  }
  .Scroller {
    width: 260px;
    height: 100%;
    overflow: hidden auto;
  }
  .CalenderWrapper {
    height: 300px;
  }
`

export default ExpandableSidebar
